declare namespace $ {

	export class $shm_hitalama_guide_text extends $shm_hitalama_text {
		page_uri( id: any): string
	}
	
}

//# sourceMappingURL=text.view.tree.d.ts.map